function l(o, s = "default", n = []) {
  const t = o.$slots[s];
  return t === void 0 ? n : t();
}
export {
  l as getSlot
};
